import DisplayLine from "../../../../shared/DisplayLine";
import {formatISODate} from "../../../../../utils/dateHelpers";
import * as React from "react";
import {Stack} from "../../../../shared/layouts";
import { useMediaQuery } from '@dnhb/node_package';
import {useTheme} from "@emotion/react";
import {useTranslation} from "react-i18next";
import Card from "../../../../shared/Card";

const CompletedForm = ({completed_at}: { completed_at: string }) => {
    const {breakpoints} = useTheme();
    const {t} = useTranslation();

    const isMinDesktop = useMediaQuery(
        `(min-width: ${breakpoints.ml ?? '56.25rem'})`
    );

    return (
        <Card>
            <Stack space={isMinDesktop ? 'm' : 's'}>
                <DisplayLine
                    label={t('Status')}
                    value={t('Afgerond')}
                />
                <DisplayLine
                    label={t('Gedeeld op')}
                    value={formatISODate(completed_at)}
                />
            </Stack>
        </Card>
    )
}
export default CompletedForm;
